"use client"

import { event } from "@/lib/gtag"

type EventParams = {
  action: string
  category: string
  label?: string
  value?: number
  [key: string]: any
}

export function useAnalytics() {
  // Fonction pour suivre un événement personnalisé
  const trackEvent = (params: EventParams) => {
    event(params)
  }

  // Fonction améliorée pour suivre les clics sur les boutons de réservation
  const trackReservationClick = (studioType?: string, location?: string) => {
    trackEvent({
      action: "reservation_click",
      category: "conversion",
      label: studioType || "general",
      location: location || "unknown",
      timestamp: new Date().toISOString(),
    })
  }

  // Fonction pour suivre les vues de section
  const trackSectionView = (sectionName: string) => {
    trackEvent({
      action: "section_view",
      category: "engagement",
      label: sectionName,
      timestamp: new Date().toISOString(),
    })
  }

  // Fonction pour suivre le pourcentage de la page explorée
  const trackScrollDepth = (percentage: number) => {
    trackEvent({
      action: "scroll_depth",
      category: "engagement",
      value: percentage,
      timestamp: new Date().toISOString(),
    })
  }

  // Fonction pour suivre les clics sur les liens externes
  const trackExternalLinkClick = (url: string, linkText?: string) => {
    trackEvent({
      action: "external_link_click",
      category: "outbound",
      label: linkText || url,
      url: url,
      timestamp: new Date().toISOString(),
    })
  }

  // Fonction pour suivre les téléchargements
  const trackDownload = (fileType: string, fileName: string) => {
    trackEvent({
      action: "download",
      category: "engagement",
      label: fileName,
      file_type: fileType,
      timestamp: new Date().toISOString(),
    })
  }

  // Fonction pour suivre les interactions avec les formulaires
  const trackFormInteraction = (formName: string, action: "start" | "submit" | "error") => {
    trackEvent({
      action: `form_${action}`,
      category: "form",
      label: formName,
      timestamp: new Date().toISOString(),
    })
  }

  // Fonction pour suivre les vues de page spécifiques
  const trackPageView = (pageName: string, pageType?: string) => {
    trackEvent({
      action: "page_view",
      category: "navigation",
      label: pageName,
      page_type: pageType || "standard",
      timestamp: new Date().toISOString(),
    })
  }

  return {
    trackEvent,
    trackReservationClick,
    trackSectionView,
    trackScrollDepth,
    trackExternalLinkClick,
    trackDownload,
    trackFormInteraction,
    trackPageView,
  }
}
